<template>
    <button class="action-button">
        <span class="fa fa-times"></span>
    </button>
</template>
<script>
export default {
    name: 'ActionButton',
};
</script>